import { resolvePartnerByHost, type PartnerConfig } from '@/config/partners'

export const PARTNER_COOKIE_NAME = 'roave_partner'
export const PARTNER_COOKIE_MAX_AGE = 7776000

const NOINDEX_PREFIXES = ['/hotels', '/hotel', '/booking', '/booking-confirmation']

export interface PartnerRequestPlan {
  readonly partner: PartnerConfig | null
  readonly rewriteTo: string | null
  readonly setCookie: boolean
  readonly noindex: boolean
}

const EMPTY_PLAN = Object.freeze({
  partner: null,
  rewriteTo: null,
  setCookie: false,
  noindex: false,
} as const satisfies PartnerRequestPlan)

const isFunnelPath = (path: string): boolean =>
  NOINDEX_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))

// The one place that knows the partner landing route's URL shape. Used by
// planPartnerRequest below (the host->/ rewrite target) and by PartnerBar's
// route gate (to know when it's on that same route and should defer to the
// landing page's own co-branded band instead of also showing itself), so
// the two can never drift apart on what "the landing route" means.
export const buildPartnerLandingPath = (partner: PartnerConfig): string =>
  `/partners/${partner.slug}`

export const planPartnerRequest = (input: {
  host: string | null | undefined
  path: string
}): PartnerRequestPlan => {
  const partner = resolvePartnerByHost(input.host)
  if (!partner) return EMPTY_PLAN

  return {
    partner,
    rewriteTo: input.path === '/' ? buildPartnerLandingPath(partner) : null,
    setCookie: true,
    noindex: isFunnelPath(input.path),
  }
}
